// src/components/Receipt.js
import React from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './Receipt.css';

export default function Receipt() {
  const { orderId } = useParams();
  const [order, setOrder] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const fetchOrder = async () => {
      try {
        console.log('Fetching order with ID:', orderId);
        const { data, error } = await supabase
          .from('orders')
          .select('*')
          .eq('id', orderId)
          .single();

        console.log('Order data from Supabase:', data);
        if (error) throw error;
        setOrder(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderId]);

  if (loading) return <div className="loading">Loading receipt...</div>;
  if (error) return <div className="error">Error: {error}</div>;
  if (!order) return <div>Order not found</div>;

  console.log('Rendering receipt with order:', order);

  const doordashTotal = parseFloat(order.screenshot_total || 0);
  const yourTotal = parseFloat(order.total || 0);
  const amountSaved = doordashTotal - yourTotal;
  const savingsPercentage = Math.round((amountSaved / doordashTotal) * 100);

  return (
    <div className="receipt-container">
      <h2>Order Confirmation</h2>
      <div className="receipt">
        <div className="receipt-header">
          <h3>Receipt #{order.id.slice(0, 8).toUpperCase()}</h3>
          <div className="receipt-date">
            {new Date(order.created_at).toLocaleDateString()}
          </div>
        </div>

        <div className="receipt-details">
          <div className="receipt-row">
            <span>DoorDash Total:</span>
            <span>${doordashTotal.toFixed(2)}</span>
          </div>
          <div className="receipt-row">
            <span>Your Price:</span>
            <span className="highlight">${yourTotal.toFixed(2)}</span>
          </div>
          <div className="receipt-divider"></div>
          <div className="receipt-row total-savings">
            <span>You Saved:</span>
            <span className="savings">-${amountSaved.toFixed(2)} ({savingsPercentage}%)</span>
          </div>
        </div>

        {order.screenshot_url && (
          <div className="receipt-image">
            <img 
              src={supabase.storage.from('screenshots').getPublicUrl(order.screenshot_url).data.publicUrl} 
              alt="Receipt" 
            />
          </div>
        )}

        <div className="receipt-footer">
          Thank you for your order!
        </div>
      </div>
    </div>
  );
}